export const getFileExtension = (url: string) => {
    if (url !== '') {
        return url?.substr(url?.lastIndexOf('.') + 1)
    }
    return ''
}
